import { ModuleAdminPage } from "./ModuleAdminPage";
export function AdminRedPacketPage() { return <ModuleAdminPage title="紅包池" code="red-packet" text="新增/編輯/停用紅包池，設定券種、獎項、機率與倍率備註。" />; }
